import AuthContext from '@context/auth';

import { getAuth } from '@services/identity.service';
import useScrollToTopOnRouteChange from '@ui/hooks/useScrollToTopOnRouteChange';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useContext, useMemo, useRef, useState } from 'react';
const Footer = dynamic(() => import('@molecules/Footer'), {
    ssr: false,
});
const NavHeader = dynamic(() => import('@molecules/NavHeader'), {
    ssr: false,
});
import bottomNavigationTexts from '@molecules/BottomNavigation/en.json';
import { useWindowSize } from '@uidotdev/usehooks';
import BottomNavigation from '@molecules/BottomNavigation';
import { cn } from '@ui/atoms/utils/utils';
import { showAppDownloadBanner } from '@helpers/constants';
import DownloadAppTicker from '@components/Homepage/CarouselBanner/DownloadAppTicker';
import useIntersection from '@ui/hooks/useIntersection';

const OpportunityLayout = ({ children }) => {
    useScrollToTopOnRouteChange();
    const router = useRouter();
    const { loginOrSignupModal, logout, investor, rmDetails, showRMDetails } =
        useContext(AuthContext);
    const auth = getAuth();
    const [isBottomNavVisible, setIsBottomNavVisible] = useState(false);
    const showBottomNavigation = ['/opportunities'].includes(router?.pathname);
    const canShowAppDownloadBanner =
        ![
            '/bond-directory',
            '/bonds',
            '/opportunities/closed',
            '/opportunity/[id]',
            '/bonds/isin/[isin]',
        ].includes(router.pathname) && showAppDownloadBanner;
    const footerRef = useRef(null);
    const isFooterVisible = useIntersection(footerRef);

    const { width } = useWindowSize();

    const scrollPosition = useMemo(() => {
        if (router.pathname.includes('/opportunity/')) {
            return width > 1280 ? 364 : 460;
        }
        if (router.pathname.includes('/bond-directory/search')) {
            return width > 1280 ? 310 : 162;
        }
        if (router.pathname.includes('/bond-directory')) {
            return width > 1280 ? 310 : 336;
        }
        if (router.pathname.includes('/bonds')) {
            return width > 1280 ? 310 : 200;
        }
        return 200;
    }, [router?.pathname, width]);

    return (
        <main
            className={cn(
                'relative flex flex-col justify-between w-full min-h-screen pb-0',
                {
                    'pb-[68px] xl:pb-0': isBottomNavVisible
                }
            )}
        >
            <NavHeader
                hideHeaderOnScroll={false}
                translucent
                isDarkMode
                scrollPosition={scrollPosition}
            />
            <div
                className={`flex flex-col w-full min-h-screen`}
            >
                {children}
                {loginOrSignupModal()}
            </div>
            <div ref={footerRef}>
                <Footer entityType={auth?.entityType} />
            </div>
            {width && width < 1280 && showBottomNavigation ? (
                <BottomNavigation
                    investor={investor}
                    visible={true}
                    rmDetails={rmDetails}
                    setIsBottomNavVisible={setIsBottomNavVisible}
                    showRMDetails={showRMDetails}
                />
            ) : canShowAppDownloadBanner ? <div className={`fixed bottom-0 w-full xl:hidden z-50 ${isFooterVisible ? 'invisible' : ''}`}><DownloadAppTicker /></div> : null}
        </main>
    );
};

export default OpportunityLayout;
